import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installProxyAuth, refreshProxyCredential } from './api/proxyAuth';

// Attach the proxy REST API bearer token to every proxy-bound fetch, before any
// component can issue one. See api/proxyAuth.js for why this is a wrapper.
installProxyAuth();

// Already logged in from a previous visit? Prime the short-lived proxy
// credential now, so the first WS connect and proxy fetch carry it instead of
// waiting for a 401/4401 round-trip (docs/proxy-credential-spec.md). Login and
// re-auth prime it themselves; this covers the reload path.
try {
    if (localStorage.getItem('auth_token')) refreshProxyCredential();
} catch { /* private mode — the 401 retry path still heals it */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
